export default __webpack_public_path__ + "0fc80db3c91ff87434e99519d676c848.svg";